var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 112,
    height: 112,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.334 48V44C68.334 42.9391 67.9126 41.9217 67.1624 41.1716C66.4123 40.4214 65.3949 40 64.334 40H40.334C39.2731 40 38.2557 40.4214 37.5056 41.1716C36.7554 41.9217 36.334 42.9391 36.334 44V58C36.334 59.0609 36.7554 60.0783 37.5056 60.8284C38.2557 61.5786 39.2731 62 40.334 62H56.334",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.333 69.9998V62.0798V68.3798",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.333 70H56.333",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.333 56H68.333C66.1239 56 64.333 57.7909 64.333 60V72C64.333 74.2091 66.1239 76 68.333 76H72.333C74.5421 76 76.333 74.2091 76.333 72V60C76.333 57.7909 74.5421 56 72.333 56Z",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR3);
export default __webpack_public_path__ + "static/media/r3.58a7e735121f4f0df4a4cab4029b90e4.svg";
export { ForwardRef as ReactComponent };